if (module.hot) {
  console.log("Accepting hot reload...");
  module.hot.accept();
}

(async () => {
  const { default: startEasasJs } = await import("./index");
  startEasasJs();
})();
